import userTypes from "./userTypes";

const INITIAL_STATE = {
  currentUser: null,
  loading: false,
};

const userReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    // logging in (sign in)
    case userTypes.SIGN_IN_START:
      return {
        ...state,
      };
    case userTypes.SIGN_IN_SUCCESS:
      return {
        ...state,
        currentUser: action.payload,
      };

    // log out (sign out)
    case userTypes.SIGN_OUT_SUCCESS:
      return {
        ...state,
        currentUser: null,
      };
    case userTypes.SESSION_EXPIRED:
      return {
        ...state,
        currentUser: "SESSION_EXPIRED",
      };

    // Change settings
    case userTypes.CHANGE_SETTINGS_START:
      return {
        ...state,
        loading: true,
      };
      case userTypes.CHANGE_SETTINGS_SUCCESS:
        return {
          ...state,
          loading: false,
          currentUser: {
            ...state.currentUser,
            user:{
              ...state.currentUser.user,
              userPreferences:action.payload
            }
          },
        };
    case userTypes.CHANGE_SETTINGS_FAILURE:
      return {
        ...state,
        loading: false,
      };

    default:
      return state;
  }
};

export default userReducer;
